import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const ModalMotivoCancelacion = ({ show, onHide, onConfirm, loading }) => {
    const [motivoCancelacion, setMotivoCancelacion] = useState('01');
    const [uuidSustituto, setUuidSustituto] = useState('');

    // Catálogo de motivos de cancelación SAT
    const motivosCancelacion = [
        { codigo: '01', descripcion: '01 - Comprobantes emitidos con errores con relación' },
        { codigo: '02', descripcion: '02 - Comprobantes emitidos con errores sin relación' },
        { codigo: '03', descripcion: '03 - No se llevó a cabo la operación' },
        { codigo: '04', descripcion: '04 - Operación nominativa relacionada en la factura global' }
    ];

    const handleConfirm = () => {
        // Validar que si el motivo es 01, se requiere UUID sustituto
        if (motivoCancelacion === '01' && !uuidSustituto.trim()) {
            alert('El motivo "Comprobantes emitidos con errores con relación" requiere un UUID sustituto');
            return;
        }

        onConfirm(motivoCancelacion, uuidSustituto.trim());
    };

    const handleHide = () => {
        // Reset al cerrar
        setMotivoCancelacion('01');
        setUuidSustituto('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Motivo de Cancelación SAT</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">
                    Para cancelar la factura ante el SAT, debe proporcionar el motivo de cancelación.
                </p>

                <Form.Group className="mb-3">
                    <Form.Label>Motivo de Cancelación <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                        value={motivoCancelacion}
                        onChange={(e) => setMotivoCancelacion(e.target.value)}
                        disabled={loading}
                    >
                        {motivosCancelacion.map((motivo) => (
                            <option key={motivo.codigo} value={motivo.codigo}>
                                {motivo.descripcion}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Text className="text-muted">
                        Seleccione el motivo según las reglas del SAT
                    </Form.Text>
                </Form.Group>

                {motivoCancelacion === '01' && (
                    <Form.Group className="mb-3">
                        <Form.Label>UUID del Comprobante Sustituto <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese el UUID del comprobante que sustituye"
                            value={uuidSustituto}
                            onChange={(e) => setUuidSustituto(e.target.value)}
                            disabled={loading}
                        />
                        <Form.Text className="text-danger">
                            Este campo es obligatorio cuando el motivo es "01 - Comprobantes emitidos con errores con relación"
                        </Form.Text>
                    </Form.Group>
                )}

                <div className="alert alert-warning mt-3">
                    <strong>Nota:</strong> La cancelación ante el SAT es irreversible. Una vez cancelada, 
                    el comprobante no podrá ser utilizado para efectos fiscales.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleHide} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={handleConfirm} disabled={loading}>
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Cancelando...
                        </>
                    ) : (
                        'Confirmar Cancelación'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalMotivoCancelacion.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

ModalMotivoCancelacion.defaultProps = {
    loading: false
};

export default ModalMotivoCancelacion;
